<template>
  <div>
    <table class="export_table" id="export_table">
      <tr style="display: none">
        <th>no</th>
        <th>registryNum</th>
        <th>mobileNum</th>
        <th>procDate</th>
        <th>action</th>
        <th>actionDesc</th>
      </tr>
      <tr>
        <th>No</th>
        <th>*가입번호</th>
        <th>*이동전화번호</th>
        <th>*처리날짜</th>
        <th>*조치내역</th>
        <th>조치기타내용</th>
      </tr>
      <tr :key="'excel_exp_' + index" v-for="(item, index) in list">
        <td>{{index + 1}}</td>
        <td>{{item.registryNum}}&#8203;</td>
        <td>{{item.mobileNum}}&#8203;</td>
        <td></td>
        <td></td>
        <td></td>
        <td v-if="index === 0">!!!!조치내역은 반드시 아래의 값중 하나를 복사해서 사용하세요!!!!</td>
        <td v-else-if="index === 1"><template v-for="(act, actIndex) in actList">{{act.codeName}}{{actIndex + 1 === actList.length ? '' : ','}}</template></td>
      </tr>
    </table>
  </div>
</template>

<script>
import xlsx from 'xlsx/xlsx'
import common from '../../script/common'

export default {
  props: ['exportData', 'filter'],
  data () {
    return {
      actList: [],
      list: this.exportData,
      localFilter: this.filter
    }
  },
  mounted () {
    let intervalCnt = 0
    let interval = setInterval(() => {
      if (common.checkValidateData('session', sessionStorage.getItem('actList'))) {
        clearInterval(interval)
        this.actList = JSON.parse(sessionStorage.getItem('actList'))
        this.$emit('prepared')
      } else if (intervalCnt > 10) {
        clearInterval(interval)
        common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
      } else {
        intervalCnt++
      }
    }, 200)
  },
  watch: {
    exportData (newVal) {
      this.list = newVal.list
    }
  },
  methods: {
    download () {
      let mainData = xlsx.utils.table_to_sheet(document.getElementById('export_table'))
      let workBook = xlsx.utils.book_new()
      xlsx.utils.book_append_sheet(workBook, mainData, 'sheet1')
      let strToday = common.getFormattedDate(Date.now()).replaceAll('-', '')
      xlsx.writeFile(workBook, '음영품질_개선_' + strToday + '_' + this.localFilter.page + '.xlsx')
    }
  }
}
</script>

<style scoped>
.export_table {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/excel/ExcelDownloadShadowQualityProgress.vue